import { createFileRoute } from "@tanstack/react-router";

import { RouteErrorFallback } from "@/components/error-message";
import { adminSeoHead } from "@/lib/seo";

export const Route = createFileRoute("/_app/_authenticated/admin/scan")({
  head: () => adminSeoHead("Scan Test"),
  errorComponent: RouteErrorFallback,
});
